export default {
  swoopAssistant: true
}
